import { cn } from '@change/ds-utils';

import { Separator } from '@change/ds-core-ui/next';

import { Circle, Rectangle, SkeletonContainer } from '../../../LoadingSkeletons';

import { circleSizes, rectangleShapes } from './header.constants';
import { HeaderStyles, NotchStyles, SeparatorStyles, SubredditInfoStyles } from './Header.styles';
import type { LoadingComponentsProps } from './types';

const gaps = {
	small: 'gap-0.5',
	medium: 'gap-1.5',
	large: 'gap-1.5',
};

export function HeaderLoading({ size }: LoadingComponentsProps) {
	return (
		<>
			<SkeletonContainer className={HeaderStyles({ size })} loading data-testid="header-loading-root">
				<Rectangle className={cn(NotchStyles({ size }), 'bg-icon-inverse-disabled')} />
				<div className={SubredditInfoStyles({ size })}>
					<Circle className={circleSizes[size]} />
					<div className={cn('flex flex-col', gaps[size])}>
						{rectangleShapes.map((rect) => (
							<Rectangle key={rect.key} className={rect.sizes[size]} rounded />
						))}
					</div>
				</div>
			</SkeletonContainer>
			<Separator className={SeparatorStyles({ size })} data-testid="header-loading-separator" />
		</>
	);
}
